import request from '@/utils/request'

// 获取用户详细信息
export const getCusInfo = params =>
  request.get(`/customer-api/customer/workflow/query/${params.id}`)
// 信用审批详情 ---> Current Credit Line字段 http://10.103.250.80:3001/project/47/interface/api/13826
export const getAuditDetail = params =>
  request.get(
    `/workflow-api/credit-apply/approve/detail/${params.bpmId}`,
    {},
    { timeout: 300000 },
  )
// 新增用户查看客户日志
export const getAddlog = params =>
  request.post('/customer-api/company-search-logs/add', params)
// 保存
export const saveAuidt = params =>
  request.post(`/workflow-api/credit-apply/approve/save`, params, {
    timeout: 300000,
  })
// 已经完成了，更新  --- update
export const completedUpdateAudit = params =>
  request.post(`/workflow-api/credit-apply/approve/update`, params, {
    timeout: 300000,
  })
// 还没有完成，更新 --- update decisions
export const completingUpdateAudit = params =>
  request.post(`/workflow-api/credit-apply/approve`, params, {
    timeout: 300000,
  })
// process过单
export const creditSubmit = params =>
  request.post('/workflow-api/credit-apply/apply', params, {
    timeout: 300000,
  })
// 派发
export const resignAudit = params =>
  request.post(`/workflow-api/work-queue/assign`, params)
// 下载文件
export const getFile = params =>
  request.get(
    `/workflow-api/credit-apply/attachment/download/${params.id}`,
    {},
    { responseType: 'blob' },
  )

export const vagueQuery = params =>
  request.get(`/customer-api/customer/list/${params.name}`)

// 查询active name
export const vagueActiveName = params =>
  request.get(`/masterdata-api/user/active/query/${params.name}`)
